import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
// eslint-disable-next-line import/no-cycle
import { Accordion } from '../accordion';
import styles from '../accordion.module.scss';
import { AccordionList } from '../accordion-list/accordion-list';
import { AccordionVariant } from '../types';
import { AccordionHeader } from './accordion-header';
export const AccordionItem = ({ children, header, displayHeader = true, description = '', headerTooltip = '', disabledTooltip = '', disabled = false, actionButtons = [], isExpanded = false, index = NaN, onItemClicked = _.noop, className = '', headerClassName = '', variant = AccordionVariant.BASIC, actionButtonsAlwaysVisible = false, noPadding = false, alignToHeader, // Don't set default here -- it's calculated below
onDisableItemClicked = _.noop, headerTitleRef = null, isExpandedWhenDisabled = false, noScrollInAccordian = false, showHeaderAsTooltip = false, noMarginBottom = false, hideCollapsedContent = false, ...restProps }) => {
    const toggleItem = () => {
        if (!disabled) {
            onItemClicked(index);
        }
    };
    const accordionItemChildrenType = children === null || children === void 0 ? void 0 : children.type;
    const isNestedAccordion = accordionItemChildrenType === Accordion ||
        accordionItemChildrenType === AccordionList ||
        variant === AccordionVariant.MULTI_LEVEL;
    // Use "alignToHeader" prop if it is passed in.
    // If not passed in, set default values as follows:
    // - nested accordions    => false
    // - all other accordions => true
    const shouldAlignToHeader = alignToHeader !== undefined ? alignToHeader : !isNestedAccordion;
    const isItemsExpanded = disabled ? isExpandedWhenDisabled : isExpanded;
    const accordionItemChildrenClass = cx(styles.accordionItemContent, styles[`accordion-${isItemsExpanded ? 'expanded' : 'collapsed'}`], {
        // Align accordion content with header text
        [styles.alignToHeader]: shouldAlignToHeader,
        // Applies padding-left: 0 for nested accordions
        // Only applied if "alignToHeader" prop is not present or if false
        [styles.noLeftPadding]: !alignToHeader && isNestedAccordion,
        [styles.noRightPadding]: isNestedAccordion,
        [styles.noPadding]: noPadding,
        [styles.accordionExpandedNoScroll]: noScrollInAccordian,
        [styles.noMarginBottom]: noMarginBottom,
    });
    // Hides collapsed content from AT and the tab order explicitly, for
    // variants that animate the collapse and so must keep it visible while
    // the animation runs. Opt-in: under the default `display: none` it is
    // redundant, and it would hide collapsed content from role queries in
    // consumers' jsdom tests, where no CSS applies.
    // `inert` alone is not enough below Safari 15.5 / Firefox 112, and must
    // be a string: React 17 drops `inert={true}` and warns.
    const collapsedAttrs = (isItemsExpanded || !hideCollapsedContent
        ? {}
        : { 'aria-hidden': true, inert: '' });
    return (React.createElement("div", { className: cx(className, styles.accordionItem, {
            [styles.accordionItemDisabled]: disabled,
        }), ...restProps },
        displayHeader && (React.createElement(AccordionHeader, { header: header, description: description, headerTooltip: disabled ? disabledTooltip : headerTooltip, toggleClass: isItemsExpanded ? 'expanded' : 'collapsed', actionButtons: actionButtons.slice(0, 2), onClick: disabled ? onDisableItemClicked : toggleItem, className: headerClassName, variant: variant, actionButtonsAlwaysVisible: actionButtonsAlwaysVisible, headerTitleRef: headerTitleRef, disabled: disabled, showHeaderAsTooltip: showHeaderAsTooltip })),
        React.createElement("div", { className: accordionItemChildrenClass, ...collapsedAttrs }, children)));
};
//# sourceMappingURL=accordion-item.js.map